const AssistantMessageStatus = Object.freeze({
  PENDING: 'pending',
  COMPLETED: 'completed',
  ERROR: 'error',
});

export default AssistantMessageStatus;
